// extracted by mini-css-extract-plugin
export default {"productCarousel":"Ul","twoColumns":"Vl","subhed":"Wl","promo":"Xl","questionIcon":"Yl","thumbContainer":"Zl","carousel":"am","tape":"bm","flexContainer":"cm","nav":"em","body":"fm","reviews":"gm","header":"hm","hed":"im","priceContainer":"jm","oldPrice":"km","newPrice":"lm","infoTabs":"mm","tabs":"nm","text":"om","questionWrapper":"pm","isQuantity":"qm","title":"rm","titleRight":"sm","addToCart":"tm","servingsPerItem":"um","quantityInput":"vm","quantityButton":"wm","takeTheQuiz":"xm"};
    if(module.hot) {
      // 1714442365974
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  